module.exports = __webpack_public_path__ + "static/media/logo_big.c18a2937.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logo_big.svg
// module id = 241
// module chunks = 0